module.exports = __webpack_public_path__ + "static/media/side_ic_alarm.02d87a00.png";